import React from "react";
import { motion } from "framer-motion";
import {
  Briefcase,
  Users,
  Target,
  TrendingUp,
  CheckCircle,
  ChevronRight,
  FileText,
  BarChart,
  Zap,
} from "lucide-react";

const JobSearchPage = () => {
  const openObraJobs = () => {
    window.open("https://app.obrajobs.com/?source=freede", "_blank");
  };

  return (
    <div className="min-h-full overflow-x-hidden">
      {/* Background orbs */}
      <div className="absolute inset-0">
        <div className="absolute -top-40 -right-40 h-80 w-80 rounded-full bg-blue-500/20 blur-3xl" />
        <div className="absolute top-40 left-0 h-80 w-80 rounded-full bg-blue-600/20 blur-3xl" />
        <div className="absolute bottom-40 right-20 h-80 w-80 rounded-full bg-indigo-500/20 blur-3xl" />
      </div>

      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="relative max-w-7xl mx-auto px-6 py-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-12"
          >
            {/* Obra Logo */}
            <div className="flex items-center justify-center mb-6">
              <svg
                height="40"
                fill="none"
                viewBox="0 0 148 40"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_6018_1059)">
                  <path
                    d="M57.2029 11.8674H50.4311V0.3953H43.4688V25.4028C43.4688 29.1485 44.8147 32.3507 47.5089 35.0105C50.2019 37.6704 53.4341 39.0009 57.2029 39.0009C60.9717 39.0009 64.2086 37.6716 66.9125 35.0105C69.6164 32.3507 70.9684 29.1485 70.9684 25.4028C70.9684 21.6571 69.6164 18.4393 66.9125 15.8108C64.2086 13.1835 60.9717 11.8686 57.2029 11.8686V11.8674ZM61.9884 30.2862C60.6859 31.6481 59.0855 32.329 57.186 32.329C55.2865 32.329 53.6849 31.6481 52.3836 30.2862C51.0811 28.9244 50.4311 27.2974 50.4311 25.4028V18.5405H57.1872C59.065 18.5405 60.6605 19.2166 61.9739 20.5676C63.286 21.9199 63.9433 23.5312 63.9433 25.404C63.9433 27.2769 63.2921 28.9268 61.9896 30.2874L61.9884 30.2862Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M77.7242 15.8265C75.03 18.4646 73.6841 21.6571 73.6841 25.4028V39.0009H80.6476V25.4028C80.6476 23.53 81.3073 21.9187 82.6279 20.5664C83.9485 19.2154 85.5453 18.5393 87.4194 18.5393H92.469V11.8674H87.4194C83.6494 11.8674 80.4185 13.1871 77.7254 15.8252L77.7242 15.8265Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M8.31421 17.4016C9.29711 11.524 14.3962 7.04067 20.5565 7.04067C27.4199 7.04067 32.9833 12.6002 32.9833 19.4589C32.9833 25.6137 28.4969 30.7092 22.6164 31.6927V38.8057C32.4008 37.7764 40.0277 29.5089 40.0277 19.4589C40.0289 8.71226 31.3106 0 20.5565 0C10.4983 0 2.22502 7.62278 1.19629 17.4016H8.31421Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M0 35.0804L4.92417 40L13.593 31.3371V38.9009H20.5566V19.4649H1.10712V26.4236H8.66162L0 35.0804Z"
                    fill="#ED6630"
                  ></path>
                  <path
                    d="M115.943 15.8578C113.239 13.198 110.002 11.8674 106.233 11.8674C102.464 11.8674 99.2322 13.198 96.5392 15.8578C93.8449 18.5176 92.499 21.721 92.499 25.4655C92.499 29.21 93.8449 32.4025 96.5392 35.0419C99.2322 37.6812 102.464 38.9997 106.233 38.9997H107.354L112.35 32.3278H106.216C104.337 32.3278 102.742 31.6529 101.43 30.3007C100.116 28.9497 99.4602 27.3372 99.4602 25.4643C99.4602 23.5914 100.111 21.9428 101.413 20.5809C102.715 19.219 104.317 18.5381 106.215 18.5381C108.113 18.5381 109.715 19.219 111.017 20.5809C112.32 21.9428 112.971 23.571 112.971 25.4643L112.965 38.9985H119.999V25.4643C119.999 21.7198 118.647 18.5164 115.942 15.8566L115.943 15.8578Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M137.291 39.4451L133.351 30.5509H134.946L137.702 37.0766L140.457 30.5509H142.052L138.112 39.4451H137.291ZM133.061 39.4451V30.5509H134.608V39.4451H133.061ZM140.795 39.4451V30.5509H142.342V39.4451H140.795ZM127.261 39.4451V31.3243H128.807V39.4451H127.261ZM124.554 31.9044V30.5509H131.514V31.9044H124.554Z"
                    fill="currentColor"
                  ></path>
                </g>
              </svg>
            </div>

            <h1 className="text-4xl md:text-5xl font-bold text-white mb-2">
              Where the opportunities find{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-blue-500">
                you.
              </span>
            </h1>
            <p className="text-xl text-blue-400 font-semibold mb-2">
              Start your next chapter, grow your income, and take control of
              your financial future.
            </p>
            <p className="text-gray-300 text-lg max-w-3xl mx-auto">
              Your career is more than a title, it's your story. With Obra, a
              career platform for the future of work, opportunities don't wait,
              they find you.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Features Section */}
      <div className="relative">
        <div className="max-w-7xl mx-auto px-6 pb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Discover career tools that are tailored to your goals.
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              {
                icon: FileText,
                title: "See where you are at with your application",
                description:
                  "Track applications status in one place with our job tracker.",
              },
              {
                icon: Briefcase,
                title: "A job for everyone",
                description:
                  "Explore over 3 million+ jobs. Ones your actually interested in.",
              },
              {
                icon: Target,
                title: "Your career is more than a resume",
                description:
                  "Uses Obra to create your workwallet, your career data center you own",
              },
              {
                icon: Zap,
                title: "AI powered job matches",
                description:
                  "Personalized AI job recommendation and feedback including a gap analysis on jobs.",
              },
            ].map((feature, index) => {
              const Icon = feature.icon;
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  whileHover={{ scale: 1.05 }}
                  className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700 hover:border-blue-500/50 transition-all cursor-pointer"
                  onClick={openObraJobs}
                >
                  <div className="w-14 h-14 rounded-xl bg-gradient-to-r from-blue-500/20 to-blue-600/20 flex items-center justify-center mb-4">
                    <Icon className="w-7 h-7 text-blue-400" />
                  </div>
                  <h3 className="text-lg font-semibold text-white mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-gray-400 text-sm">{feature.description}</p>
                </motion.div>
              );
            })}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mt-12"
          >
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={openObraJobs}
              className="inline-flex items-center gap-3 px-10 py-5 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-bold text-lg rounded-full shadow-lg hover:shadow-xl transition-all"
            >
              Find your next job
              <ChevronRight size={24} />
            </motion.button>
          </motion.div>
        </div>
      </div>

      {/* Stats Section */}
      <div className="relative">
        <div className="max-w-7xl mx-auto px-6 py-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-12 border border-gray-700"
          >
            <h2 className="text-3xl font-bold text-white text-center mb-12">
              Because the right job isn't something you chase—it comes to you.
            </h2>

            <div className="grid md:grid-cols-3 gap-8 mb-12">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
                className="text-center"
              >
                <div className="w-20 h-20 rounded-full bg-gradient-to-r from-blue-500 to-blue-600 flex items-center justify-center mx-auto mb-4">
                  <Briefcase className="w-10 h-10 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">
                  3+ Million Jobs
                </h3>
                <p className="text-gray-400">
                  Opportunities across all industries
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                className="text-center"
              >
                <div className="w-20 h-20 rounded-full bg-gradient-to-r from-blue-500 to-blue-600 flex items-center justify-center mx-auto mb-4">
                  <BarChart className="w-10 h-10 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">
                  34+ Industries
                </h3>
                <p className="text-gray-400">
                  Find your perfect industry match
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.3 }}
                className="text-center"
              >
                <div className="w-20 h-20 rounded-full bg-gradient-to-r from-blue-500 to-blue-600 flex items-center justify-center mx-auto mb-4">
                  <Users className="w-10 h-10 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">
                  Looking for You!
                </h3>
                <p className="text-gray-400">
                  Personalized job recommendations
                </p>
              </motion.div>
            </div>

            <div className="text-center">
              <p className="text-gray-300 text-lg mb-8">
                Obra's ready to help connect opportunities with you.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default JobSearchPage;
